module.exports = __webpack_public_path__ + "static/media/chevronLeft.1ea47157.svg";